var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashinicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.262,
    height: 58.949,
    viewBox: "0 0 55.262 58.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M147.055,238.551a4.724,4.724,0,0,0,1.853,3.983,15.005,15.005,0,0,0,4.643,2.6c4.649,1.741,9.5,2.252,14.993,2.345,1.058-.063,2.692-.116,4.317-.264a35.614,35.614,0,0,0,9.9-2.2,14.675,14.675,0,0,0,4.339-2.485,4.738,4.738,0,0,0,1.849-3.986c-.068-1.325-.064-2.659,0-3.985a4.643,4.643,0,0,0-1.756-3.829,14.812,14.812,0,0,0-4.8-2.716,37.054,37.054,0,0,0-10.508-2.135,45.987,45.987,0,0,0-16.733,1.609,16.757,16.757,0,0,0-6.291,3.2,4.676,4.676,0,0,0-1.8,3.94A37.339,37.339,0,0,1,147.055,238.551Z",
    transform: "translate(-133.689 -225.736)",
    fill: "#93b42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M179.493,267.863a16.42,16.42,0,0,0,6.218-3.2,4.657,4.657,0,0,0,1.774-3.887c-.067-1.326-.012-2.658-.015-3.986,0-.184-.023-.367-.037-.586-.786.461-1.495.925-2.245,1.305-4.855,2.469-10.089,3.364-15.451,3.706a4.91,4.91,0,0,1,.27,1.609,5.376,5.376,0,0,1-1.993,4.075l-3.056,2.718A44.194,44.194,0,0,0,179.493,267.863Z",
    transform: "translate(-132.23 -223.253)",
    fill: "#93b42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M188.414,269.512v-1.721c-.825.484-1.534.948-2.283,1.328-4.949,2.511-10.285,3.4-15.752,3.722a52.063,52.063,0,0,1-8.884-.25l-1.246,1.108-2.889,2.57c-.16.142-.319.286-.478.428-.484.436-.984.886-1.532,1.339a5.714,5.714,0,0,1-1.962,1.044,37.525,37.525,0,0,0,10.318,2.039,45.84,45.84,0,0,0,16.791-1.666,16.327,16.327,0,0,0,6.157-3.178,4.611,4.611,0,0,0,1.77-3.887C188.365,271.432,188.414,270.47,188.414,269.512Z",
    transform: "translate(-133.172 -222.309)",
    fill: "#93b42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M147.215,273.437c.013.043.026.087.04.13v-.145Z",
    transform: "translate(-133.675 -221.851)",
    fill: "#93b42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M147.311,250.95a5.179,5.179,0,0,1,3.017-4.194,25.571,25.571,0,0,1-3.263-1.828c0,1.579.018,3.053-.006,4.527A4.013,4.013,0,0,0,147.311,250.95Z",
    transform: "translate(-133.688 -224.172)",
    fill: "#93b42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M185.479,253.745c1.261-.876,2.442-1.92,2.6-3.516.169-1.718.039-3.466.039-5.258a2.249,2.249,0,0,0-.265.126,26.256,26.256,0,0,1-9.053,3.715,51.839,51.839,0,0,1-17.709.928c-1.486-.172-2.956-.394-4.4-.689,2.088,1.843,4.182,3.7,6.219,5.506l1.673,1.483.814.722q.706.626,1.413,1.251a46.45,46.45,0,0,0,10.866-1.115A21.833,21.833,0,0,0,185.479,253.745Z",
    transform: "translate(-132.904 -224.169)",
    fill: "#93b42e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M157.05,272.969l3.919-3.485q3.184-2.832,6.369-5.664c.544-.484.543-.583-.019-1.079-.394-.347-.785-.7-1.178-1.044q-1.457-1.288-2.91-2.577l-2.533-2.245q-3.45-3.059-6.907-6.108a.738.738,0,0,0-.446-.151.442.442,0,0,0-.135.018c-.115.039-.2.327-.2.5-.014,1.054,0,2.109,0,3.162v.284c0,.712,0,1.424,0,2.164-.135.012-.217.022-.3.026a16.046,16.046,0,0,0-3.441.576q-.605.169-1.194.385a16.884,16.884,0,0,0-3.051,1.482,19.951,19.951,0,0,0-8.03,9.838,34.663,34.663,0,0,0-2.3,13.115c0,.243.048.444.327.482a.6.6,0,0,0,.074.005c.269,0,.346-.226.416-.449a16.98,16.98,0,0,1,6.182-8.573,19.416,19.416,0,0,1,6.389-3.276q.691-.2,1.407-.335a16.627,16.627,0,0,1,1.677-.241c.223-.02.447-.026.672-.026.387,0,.777.018,1.177.018v.5q0,.712-.007,1.424c-.007,1.237-.012,2.473,0,3.709,0,.2.1.538.223.571a.418.418,0,0,0,.1.012.93.93,0,0,0,.532-.206c.643-.531,1.257-1.1,1.881-1.655Z",
    transform: "translate(-134.695 -223.709)",
    fill: "#93b42e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashinicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/cash.in.icon.74f6b4d6a0bbfdcce5cb89fb493401c9.svg";
export { ForwardRef as ReactComponent };